import CircleButtonUIV1 from "./CircleButton/v1";
import CircleButtonUIV2 from "./CircleButton/v2";
import BaseButtonUIV1 from "./BaseButton/v1";
import BaseButtonUIV2 from "./BaseButton/v2";
import BackButtonUIV2 from "./BackButton/v2";

import { withVersions } from "v2/hocs/withVersions";

const CircleButton = withVersions({
  v1: CircleButtonUIV2,
  v2: CircleButtonUIV2,
});

const BaseButton = withVersions({
  v1: BaseButtonUIV1,
  v2: BaseButtonUIV2,
});

const BackButton = withVersions({
  v1: BackButtonUIV2,
  v2: BackButtonUIV2,
});

export { CircleButton, BaseButton, BackButton };
